import moment from 'moment'


export const validateDateString = (dateString, format) => {
  try{
    var date = moment(dateString+' UTC', format).utc()
    if(date.isValid()){
      return date
    }else{
      return false
    }
  }catch(err){
    return false
  }
}

export const convertDateTimeToDate = (dateTime, format)=>{
  try{
    if(dateTime) return moment(dateTime).format(format)
  }catch(err){}
  return ''
}



// WEBPACK FOOTER //
// ./src/inputValidator.js